module.exports = __webpack_public_path__ + "images/product-icon-15-years-warranty.aa6267.svg";